import Element from "./index";
import { RouteType } from "routes/types";

const route: RouteType = {
  id: 1330,
  parentId: 1300,
  name: "ConferencePapers",
  label: "Conference Papers",
  path: "conference_papers",
  element: Element,
  footer: true,
  user: false,
  admin: false,
  hidden: false,
};

export default route;
